import React from 'react'
import PropTypes from 'prop-types'

import Item from './Item'

const Blogs = ({ blogs }) => (
  <section className='background-image padding-tb-100px sm-ptb-35px'>
    <div className='container'>
      <div className='row justify-content-center'>
        <div className='col-lg-7'>
          <div className='firo-title dark text-center wow fadeInUp' data-wow-delay='0.2s'>
            <h2 className='title'>Blogs</h2>
            <div className='description'>List of useful articles and blog post on Node.js</div>
          </div>
        </div>
      </div>

      <div className='row'>
        {
          blogs.map((blog, index) => <Item key={index} {...blog} />)
        }
      </div>
    </div>
  </section>
)

Blogs.propTypes = {
  blogs: PropTypes.arrayOf(PropTypes.shape())
}

Blogs.defaultProps = {
  blogs: []
}

export default Blogs
